/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ApprovalError =
  | 'UNKNOWN'
  | 'GATED'
  | 'INVALID_REQUEST'
  | 'NOT_FOUND'
  | 'APPROVAL_ALREADY_EXISTS'
  | 'TRANSITION_NOT_PERMITTED'
  | 'NOT_AUTHORIZED'
  | 'APPROVER_INVALID'
  | 'APPROVALS_NOT_ENABLED'
  | 'APPROVAL_TEMPLATE_CHANGED'
  | 'TOO_MANY_REQUESTS'
  | unhandledEnumCase;

export type ApprovalAction =
  | 'PUBLISH'
  | 'MOVE_STAGE'
  | 'INSTALL'
  | unhandledEnumCase;

export type ApprovalSettingsDisplayCategory =
  | 'WEB_CONTENT'
  | 'MARKETING'
  | 'REVENUE'
  | 'DATA_EXPORTS'
  | unhandledEnumCase;

export type ApprovalChirpError = {
  errorType: ApprovalError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ApprovalOption = {
  value: string;
  labels: Default<Record<string, string>>;
};

export type ApprovalSettingsAsset = {
  objectTypeId: string;
  label: string;
  approvalAction: ApprovalAction;
  approvalReadScope: string;
  kbArticleUrl?: string;
  isDisplayedOnFrontend?: boolean;
  displayCategory?: ApprovalSettingsDisplayCategory;
  skipApprovalsEnabled: boolean;
  changesRequestedEnabled: boolean;
  rejectionEnabled: boolean;
  anyoneCanApproveRuleEnabled: boolean;
  sequentialApprovalRuleEnabled: boolean;
  approverUpdatesEnabled: boolean;
  republishingEnabled: boolean;
  agentApproverEnabled: boolean;
  teamApproverEnabled: boolean;
  approvalTemplatesEnabled: Default<boolean>;
};

export type ListApprovalSettingsAssetsRequest = {};

export type ListApprovalTypeOptionsRequest = {};

/**
 *  The Breeze agent ids to resolve display names for. The FE runs on app auth and cannot call the
 *  INTERNAL-only {@code BreezeEngineAdminService}, so it batches the agent ids shown in one view
 *  (approver pickers, activity feeds) into a single call here.
 */
export type ResolveBreezeAgentNamesRequest = { agentIds: Default<string[]> };

export type ListApprovalSettingsAssetsResponse = {
  assets: Default<ApprovalSettingsAsset[]>;
};

export type ListApprovalTypeOptionsResponse = {
  options: Default<ApprovalOption[]>;
};

export type ResolveBreezeAgentNamesResponse = {
  agents: Default<ResolvedBreezeAgentName[]>;
};

/**
 *  The display name for one Breeze agent, echoing the requested id so callers can match results back
 *  regardless of order. {@code displayName} is empty when the agent is not found, not visible to the
 *  caller, or Breeze could not be reached — the FE falls back to the raw agent ID in that case.
 */
export type ResolvedBreezeAgentName = { agentId: string; displayName?: string };

export type ListApprovalSettingsAssetsRequestType =
  Requestify<ListApprovalSettingsAssetsRequest>;
export type ListApprovalSettingsAssetsResponseType =
  ListApprovalSettingsAssetsResponse;
export type ListApprovalSettingsAssetsErrorType = ApprovalChirpError &
  HubspotMetadata;
export const listApprovalSettingsAssetsRpc: ChirpAvroRpcDetails<
  ListApprovalSettingsAssetsRequestType,
  ListApprovalSettingsAssetsResponseType,
  ListApprovalSettingsAssetsErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc',
  rpcName: 'listApprovalSettingsAssets',
  auth: 'app',
  fingerprint: 'e6dgMuePSY28pzJuLQzazoT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListApprovalTypeOptionsRequestType =
  Requestify<ListApprovalTypeOptionsRequest>;
export type ListApprovalTypeOptionsResponseType =
  ListApprovalTypeOptionsResponse;
export type ListApprovalTypeOptionsErrorType = ApprovalChirpError &
  HubspotMetadata;
export const listApprovalTypeOptionsRpc: ChirpAvroRpcDetails<
  ListApprovalTypeOptionsRequestType,
  ListApprovalTypeOptionsResponseType,
  ListApprovalTypeOptionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc',
  rpcName: 'listApprovalTypeOptions',
  auth: 'app',
  fingerprint: 'XFeHNuAUYjPLbTiCd2WSCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveBreezeAgentNamesRequestType =
  Requestify<ResolveBreezeAgentNamesRequest>;
export type ResolveBreezeAgentNamesResponseType =
  ResolveBreezeAgentNamesResponse;
export type ResolveBreezeAgentNamesErrorType = ApprovalChirpError &
  HubspotMetadata;
export const resolveBreezeAgentNamesRpc: ChirpAvroRpcDetails<
  ResolveBreezeAgentNamesRequestType,
  ResolveBreezeAgentNamesResponseType,
  ResolveBreezeAgentNamesErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc',
  rpcName: 'resolveBreezeAgentNames',
  auth: 'app',
  fingerprint: '1DAwWBblEPVEiMxbS5fnN4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
